import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import * as React from 'react';

import { cn } from '@/lib/utils';

import { Button, ButtonProps } from '../arandu/button';

const AlertDialog = AlertDialogPrimitive.Root;

const AlertDialogTrigger = AlertDialogPrimitive.Trigger;

const AlertDialogPortal = AlertDialogPrimitive.Portal;

const AlertDialogOverlay = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <AlertDialogPrimitive.Overlay
    className={cn('bg-ctx-layout-overlay/deep data-[state=open]:animate-overlayShow fixed inset-0 z-[998]', className)}
    {...props}
  />
);

const AlertDialogContent = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <AlertDialogPortal>
    <AlertDialogOverlay />
    <AlertDialogPrimitive.Content
      className={cn(
        'data-[state=open]:animate-contentShow w-[90%] sm:w-full max-w-[24rem] bg-ctx-layout-spotlight space-y-mini border border-base-gray-100 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md p-xxxs shadow-level4 fixed focus:outline-none',
        className,
      )}
      {...props}
    />
  </AlertDialogPortal>
);

const AlertDialogHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col gap-nano text-center sm:text-left', className)} {...props} />
);
AlertDialogHeader.displayName = 'AlertDialogHeader';

const AlertDialogClose = ({ className, ...props }: React.ComponentProps<typeof AlertDialogPrimitive.Cancel>) => (
  <AlertDialogPrimitive.Cancel
    className={cn(
      'absolute right-xxxs top-xxxs text-ctx-content-base/semiOpaque hover:text-ctx-content-base',
      className,
    )}
    {...props}
  />
);

const AlertDialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex justify-center sm:justify-end sm:gap-xs', className)} {...props} />
);

const AlertDialogTitle = ({ className, ...props }: React.ComponentProps<typeof AlertDialogPrimitive.Title>) => (
  <AlertDialogPrimitive.Title className={cn('text-ctx-content-title ts-heading-sm', className)} {...props} />
);

const AlertDialogDescription = ({ className, ...props }: React.ComponentProps<'p'>) => (
  <AlertDialogPrimitive.Description
    className={cn('text-ctx-content-base/semiOpaque ts-paragraph-xs', className)}
    {...props}
  />
);

/** Os dois botões do diálogo são grandes no design system; quem chamar pode trocar o tamanho. */
const AlertDialogAction = ({ children, size = 'lg', ...props }: React.ComponentProps<typeof Button>) => {
  return (
    <Button size={size} {...props}>
      {children}
    </Button>
  );
};

const AlertDialogCancel = ({
  children,
  hierarchy = 'tertiary',
  size = 'lg',
  ...props
}: React.ComponentProps<typeof Button> & { hierarchy?: ButtonProps['hierarchy'] }) => (
  <AlertDialogPrimitive.Cancel asChild>
    <Button hierarchy={hierarchy} size={size} {...props}>
      {children}
    </Button>
  </AlertDialogPrimitive.Cancel>
);

export {
  AlertDialog,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogClose,
};
